import Link from 'next/link';
// @mui
import { BoxProps } from '@mui/material';
import SvgIconStyle from './SvgIconStyle';
// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function LogoPlain({ disabledLink = false, sx }: Props) {
  const logoStyles = {
    width: '28px',
    height: '28px',
    backgroundColor: 'common.white',
    ...sx,
  };

  const logo = <SvgIconStyle src="/icons/ic_logo_plain.svg" sx={logoStyles} />;

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <Link href="/">{logo}</Link>;
}
